/**
 * ORBIT LUXE — shop layer helpers (collection + product pages)
 * --------------------------------------------------------------------------
 *  1. PDP title: the catalogue repeats the brand at the start of every title
 *     ("Alexander McQueen Beige Calf…"). The brand already reads as an eyebrow
 *     above the H1, so the prefix is wrapped in a visually-hidden span — the
 *     accessible name, <title> and structured data are untouched.
 *  2. Entrance flag: html.olx-entered is set once the first-paint animations
 *     in orbit-luxe-shop.css have finished, so later section re-renders
 *     (variant changes morph the details column) don't replay them.
 */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  /* ------------------------------------------------------------------ *
   * 1. PDP brand-prefix split
   * ------------------------------------------------------------------ */
  function normalise(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function readVendor(details) {
    var el = details.querySelector('.text-block[class*="text_vendor"] p, .text-block[class*="text_vendor"]');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function splitTitle(details) {
    var h1 = details.querySelector('h1');
    if (!h1 || h1.dataset.olxSplit === '1') return;
    if (h1.children.length) {
      h1.dataset.olxSplit = '1';
      return;
    }
    var vendor = readVendor(details);
    var full = h1.textContent.replace(/\s+/g, ' ').trim();
    if (!vendor || vendor.length >= full.length) return;
    if (normalise(full).indexOf(normalise(vendor)) !== 0) return;

    var rest = full.slice(vendor.length).replace(/^[\s\-–—|:,]+/, '');
    if (!rest) return;

    h1.textContent = '';
    var brand = doc.createElement('span');
    brand.className = 'olx-pdp-brand';
    brand.textContent = vendor + ' ';
    h1.appendChild(brand);
    h1.appendChild(doc.createTextNode(rest));
    h1.dataset.olxSplit = '1';
  }

  var splitTimer = null;

  function scheduleSplit() {
    if (splitTimer) return;
    splitTimer = window.setTimeout(function () {
      splitTimer = null;
      var details = doc.querySelectorAll('.product-details');
      for (var i = 0; i < details.length; i++) splitTitle(details[i]);
    }, 40);
  }

  function initPdp() {
    var details = doc.querySelector('.product-details');
    if (!details) return;
    scheduleSplit();

    /* Variant changes re-render the details column through the section
       renderer + morph; re-apply once things settle. */
    var mo = new MutationObserver(scheduleSplit);
    mo.observe(details, { childList: true, subtree: true, characterData: true });
  }

  /* ------------------------------------------------------------------ *
   * 2. Entrance flag
   * ------------------------------------------------------------------ */
  function markEntered() {
    root.classList.add('olx-entered');
  }

  if (root.classList.contains('olx-js')) {
    window.setTimeout(markEntered, 2400);
  } else {
    markEntered();
  }

  /* ------------------------------------------------------------------ *
   * Boot
   * ------------------------------------------------------------------ */
  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', initPdp, { once: true });
  } else {
    initPdp();
  }

  doc.addEventListener('shopify:section:load', scheduleSplit);
})();
